import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, Rectangle, Space, Typography } from '@pitchero/react-ui';
import Icon from '../icon';
import ClubLink from '../club-link';

const Pagination = ({ page, route, routeParams, totalPages }) => {
  if (totalPages <= 1) {
    return null;
  }

  const renderPageLink = (pageNumber, isActive = false) => (
    <ClubLink route={route} params={{ ...routeParams, page: pageNumber }}>
      <a>
        <Space right="xsmall">
          <Rectangle fill={isActive ? 'primary' : 'alto'} radius="rounded">
            <Cushion
              horizontal={pageNumber > 9 ? 9 : 12}
              vertical="xsmall"
              component="div"
              style={{ display: 'inline-block' }}
            >
              <Typography preset="name" color={isActive ? 'primaryContrast' : 'black'}>
                {pageNumber}
              </Typography>
            </Cushion>
          </Rectangle>
        </Space>
      </a>
    </ClubLink>
  );

  const renderBack = () => {
    if (page <= 1) {
      return null;
    }

    return (
      <ClubLink route={route} params={{ ...routeParams, page: page - 1 }}>
        <a>
          <Space right="xsmall">
            <Rectangle fill="alto" radius="rounded">
              <Cushion all="xsmall" component="div" style={{ display: 'inline-block' }}>
                <Typography preset="name" color="black">
                  <Icon name="back-arrow" preset="name" />
                </Typography>
              </Cushion>
            </Rectangle>
          </Space>
        </a>
      </ClubLink>
    );
  };

  const renderForward = () => {
    if (page >= totalPages) {
      return null;
    }

    return (
      <ClubLink route={route} params={{ ...routeParams, page: page + 1 }}>
        <a>
          <Rectangle fill="alto" radius="rounded">
            <Cushion all="xsmall" component="div" style={{ display: 'inline-block' }}>
              <Typography preset="name" color="black">
                <Icon name="forward-arrow" preset="name" />
              </Typography>
            </Cushion>
          </Rectangle>
        </a>
      </ClubLink>
    );
  };

  const renderEllipsis = () => (
    <Space right="xsmall" component="div" style={{ display: 'inline-block' }}>
      <Typography preset="name" color="black">
        …
      </Typography>
    </Space>
  );

  return (
    <div>
      {renderBack()}
      {page > 2 && renderPageLink(1)}
      {page > 3 && renderEllipsis()}
      {page > 1 && renderPageLink(page - 1)}
      {renderPageLink(page, true)}
      {page < totalPages && renderPageLink(page + 1)}
      {page < totalPages - 2 && renderEllipsis()}
      {page < totalPages - 1 && renderPageLink(totalPages)}
      {renderForward()}
    </div>
  );
};

Pagination.defaultProps = {
  routeParams: {},
};

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  route: PropTypes.string.isRequired,
  routeParams: PropTypes.shape(),
  totalPages: PropTypes.number.isRequired,
};

export default Pagination;
